import React from 'react';

const variantMap = {
  success: 'badge-success',
  warning: 'badge-warning',
  danger:  'badge-danger',
  info:    'badge-info',
  neutral: 'badge-neutral',
};

const statusMap = {
  active:            'success',
  completed:         'success',
  approved:          'success',
  in_progress:       'info',
  inactive:          'neutral',
  under_maintenance: 'warning',
  cancelled:         'danger',
  pending:           'warning',
};

export default function Badge({ label, variant, status }) {
  const v = variant || statusMap[status] || 'neutral';
  return <span className={`badge ${variantMap[v]}`}>{label || status}</span>;
}